import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { flex } from "shared/theme/mixins";

export const StyledContainer = styled(Box)`
  ${flex({ fd: "column", ai: "flex-start" })};
  gap: 2px;
  height: 20px;
`;

export const StyledRectangleContainer = styled(Box, {
  shouldForwardProp: (propName) => !["bgColor"].includes(propName),
})<{
  bgColor: string;
}>`
  border-radius: 2px;
  background-color: ${({ bgColor }) => bgColor};
`;

export const StyledSingleRectangleContainer = styled(Box)`
  margin-right: 4px;
  width: 33px;
  height: 20px;
  border-radius: 2px;
  background-color: #95cde7;
`;
